var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 426,
    height: 341,
    viewBox: "0 0 426 341",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M255.45 0.0599976C163.72 0.0599976 88.99 72.69 85.54 163.57C88.96 96.17 144.69 42.58 212.93 42.58C281.17 42.58 340.49 99.69 340.49 170.14H425.53C425.53 76.21 349.38 0.0599976 255.45 0.0599976Z",
    fill: "#006464"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M212.93 297.7C142.48 297.7 85.3701 240.59 85.3701 170.14H0.330078C0.330078 264.07 76.4801 340.22 170.41 340.22C264.34 340.22 336.87 267.59 340.32 176.71C336.9 244.11 281.17 297.7 212.93 297.7Z",
    fill: "#C85F00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M340.48 170.14C340.48 99.69 283.37 42.58 212.92 42.58C142.47 42.58 85.3601 99.69 85.3601 170.14H340.48Z",
    fill: "#009B96"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3701 170.14C85.3701 240.59 142.48 297.7 212.93 297.7C283.38 297.7 340.49 240.59 340.49 170.14H85.3701Z",
    fill: "#E1BE00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.611d3f590558c26df40b18764fc61378.svg";
export { ForwardRef as ReactComponent };